import { uiActions } from '../actionTypes/ui';
import { ISnackbarNotifications } from '../../components/AppSnackbarProvider/AppSnackbarProvider';
import { LanguageCode } from '@communication-center/data-objects';

export const enqueueSnackbar = (notification: ISnackbarNotifications) => {
    const key = notification.options && notification.options.key;

    return {
        type: uiActions.ENQUEUE_SNACKBAR,
        notification: {
            ...notification,
            key: key || new Date().getTime() + Math.random()
        }
    };
};

export const closeSnackbar = (key: $TSFixMe) => ({
    type: uiActions.CLOSE_SNACKBAR,
    key
});

export const removeSnackbar = (key: $TSFixMe) => ({
    type: uiActions.REMOVE_SNACKBAR,
    key
});

export const setLanguage = (languageCode: LanguageCode) => ({
    type: uiActions.SET_LANGUAGE,
    languageCode
});